import { BigQueryEnrichmentData } from '@fiverr-private/gig_page_context';

const getBaseParams = (eventName: string, enrichmentData: BigQueryEnrichmentData) => ({
    type: eventName,
    entity: 'client',
    user: { id: enrichmentData.userId },
    seller: { id: enrichmentData.sellerId },
    gig: { id: enrichmentData.gigId },
    page: {
        name: enrichmentData.pageName,
        ctx_id: enrichmentData.pageCtxId,
    },
});

export const getBaseImpressionParams = (eventName, eventData) => ({
    ...getBaseParams(eventName, eventData),
    group: 'user_impression',
    action: { type: 'impression' },
});

export const getBaseActionsParams = (eventName, eventData) => ({
    ...getBaseParams(eventName, eventData),
    group: 'user_actions',
    action: { type: 'click' },
});
